import { ICharge } from "../interface/ISimCardRequest";

interface IChargeResponse {
    billingType: string;
    catalogChargeCode: string;
    catalogPricePlanCode: string;
    defaultPriceVatIncluded: number;
    description: string;
}

export interface ISimSwapResponse {
    charges: IChargeResponse[];
}

export const getResponseToState = (response: ISimSwapResponse): ICharge[] =>
    response.charges.map((charge) => ({
        billingType: charge.billingType,
        catalogChargeCode: charge.catalogChargeCode,
        catalogPricePlanCode: charge.catalogPricePlanCode,
        defaultPriceVatIncluded: charge.defaultPriceVatIncluded,
        description: charge.description,
    }));
